import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { isDefined } from '../../../../../../utils/utils';

interface OddsDO {
  o: string;
  v: number;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'odds',
  template: `
    @if (oddsName) {
      <div>{{ oddsName }}</div>
    }
    <div class="odds">{{ type }}{{ sign }}{{ oddsValue }}</div>
  `,
  styles: [
    `
      :host {
        font-family: 'Figtree-Regular';
        --oddsBtnHeight: 40px;
        --oddsBtnRadius: 4px;
        --oddsColor: blue;
        --oddsBkgColor: white;
        --oddsBorder: none;
        --oddsHoverBkgColor: #d2cdef;
      }
      .odds {
        font-weight: 700;
        font-size: 12px;
        background-color: var(--oddsBkgColor);
        border: var(--oddsBorder);
        border-radius: var(--oddsBtnRadius);
        color: var(--oddsColor);
        transition: transform 0.1s ease-in-out;
        text-align: center;
        vertical-align: middle;
        text-decoration: none;
        width: 60px;
        height: var(--oddsBtnHeight);
        margin: 5px;
      }
    `,
  ],
  standalone: false,
})
export class OddsComponent implements OnInit {
  @Input() odds: OddsDO | undefined;

  @Input() showSign: boolean = false;

  @Input() showType: boolean = false;

  @Input() name: string;

  sign: string = '';

  type: string = '';

  oddsValue: string = '-';

  oddsName: string = undefined;

  ngOnInit() {
    if (isDefined(this.odds)) {
      if (this.showSign) {
        this.sign = this.odds.v < 0 ? '-' : '+';
      }
      if (this.showType) {
        this.type = `${this.odds.o}:`;
      }
      this.oddsValue = `${this.odds.v}`;
      if (isDefined(this.name)) {
        this.oddsName = this.name;
      }
    }
  }
}
